import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Dashboard.css';
import Sidebar from './Sidebar';
import Dashheader from '../Dash-header/Dashheader';
import popImg from '../../images/popup-checked.svg';
import { useParams, useNavigate } from 'react-router-dom';
import { END_URL } from '../../config';

import UserFooter from '../footer/UserFooter.jsx';

const Dashboard = () => {
  const { step: urlStep } = useParams();
  const navigate = useNavigate();
  const [step, setStep] = useState(urlStep ? parseInt(urlStep) : 1);
  // const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: '',
    lastname: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    state_name:'',
    postalcode: '',
    country: '',
    country_id: '',
    dob: '',
    occupation: '',
    supermarket_used: [],
    primary_shopper: '',
    shopping_frequency: '',
    household_people: '',
    store_location: '',
    average_spend: '',
    pricing_awareness: '',
    sale_price_usage: '',
    heard_about: [],
    other_specify: '',
    preferred_contact: [],
    consent: '',
    adminlabel: '',
    eoidetails: ''
  });

  const [errors, setErrors] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    dob: '',
    country: '',
    primary_shopper: '',
    shopping_frequency: '',
    average_spend: '',
    sale_price_usage: '',
    pricing_awareness: '',
  });

  useEffect(() => {
    // Validate URL step parameter
    const parsedStep = urlStep ? parseInt(urlStep) : 1;
    if (parsedStep >= 1 && parsedStep <= 4) {
      if (parsedStep !== step) {
        setStep(parsedStep);
      }
    } else {
      navigate('/users/1', { replace: true });
    }
  }, [urlStep, navigate]);





  const [profileExists, setProfileExists] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [countries, setCountries] = useState([]);

  const [states, setstates] = useState([]);

  const [dynamicContent, setDynamicContent] = useState(null);


  const token = sessionStorage.getItem('authToken');

  const [completedTabs, setCompletedTabs] = useState([]);

 const [Isloading, setIsloading] = useState(false);


  useEffect(() => {
    const fetchUserData = async () => {
      try {


        const response = await axios.get(
          `${END_URL}users`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const data = response.data;
        setFormData((prevData) => ({
          ...prevData,
          ...data,
        }));

      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    if (token) fetchUserData();
  }, [token]);

  useEffect(() => {
    const fetchDynamicContent = async () => {
      try {
        const response = await axios.get(`${END_URL}dynamic-page`);
        setDynamicContent(response.data.data); // Assuming your API returns { data: ... }
      } catch (error) {
        console.error('Failed to fetch dynamic content:', error);
      }
    };

    fetchDynamicContent();
  }, []);


  const label = dynamicContent?.adminlabelcontents;
  const adminLabel = formData.adminlabel || "";

  const htmlContent = `<strong>${label}</strong> ${adminLabel}`;
  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await axios.get(
          `${END_URL}profiles`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );


        if (response.data) {


          const heardAbout = response.data.heard_about;

          const PreferredContact = response.data.preferred_contact;
        
          setFormData((prevData) => ({
            ...prevData,
            ...response.data,
            heard_about: typeof heardAbout === "string"
            ? JSON.parse(heardAbout)
            : Array.isArray(heardAbout)
              ? heardAbout
              : [],

            preferred_contact: typeof PreferredContact === "string"
            ? JSON.parse(PreferredContact)
            : Array.isArray(PreferredContact)
              ? PreferredContact
              : [],
          }));

          setProfileExists(true);
        } else {
          setProfileExists(false);
        }
      } catch (error) {
        console.error('Error fetching profile data:', error);
        setProfileExists(false);
      }
    };

    if (token) fetchProfileData();
  }, [token]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(
          `${END_URL}countries`  // Using END_URL from config
        );


        if (response.data && response.data.countries && Array.isArray(response.data.countries)) {
          setCountries(response.data.countries);
        } else {
          setCountries([]);
        }
      } catch (error) {
        console.error('Failed to fetch countries:', error);
        setCountries([]);
      }
    };

    fetchCountries();
  }, []);


    useEffect(() => {
      
      fetchStates(formData.country_id);

    }, [formData.country_id]);
        
    const fetchStates = async (country_id) => {

        try {
          if (country_id) { 
            const response = await axios.get(`${END_URL}states/${country_id}`);

            if (response.data && Array.isArray(response.data.states)) {
              setstates(response.data.states);
            } else {
              setstates([]);
            }
          } else {
            setstates([]);
          }
        } catch (error) {
          console.error("Error fetching states:", error);
          setstates([]);
        }
    };	



  const nextStep = () => {
    if (step === 1) {
      if (validateForm()) { // Your existing validation function for step 1
        // Mark step 1 as completed if not already
        setCompletedTabs((prev) => (prev.includes(1) ? prev : [...prev, 1]));
        const newStep = 2;
        setStep(newStep);
        navigate(`/users/${newStep}`, { replace: true });
      } else {
        // Don't proceed if validation fails
        return;
      }
    } else {
      // For other steps, proceed normally without extra validation here

      setCompletedTabs((prev) => (prev.includes(step) ? prev : [...prev, step]));

      const newStep = Math.min(step + 1, 4);
      setStep(newStep);
      navigate(`/users/${newStep}`, { replace: true });
    }
  };

  const prevStep = () => {
    const newStep = Math.max(step - 1, 1);
    setStep(newStep);
    navigate(`/users/${newStep}`, { replace: true }); // Update URL
  };


  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => {

      if (name === 'consent' && type === 'checkbox') {
        return {
          ...prevData,
          consent: checked ? 'Yes' : 'No',
        };
      }

      if (type === 'checkbox') {
        return {
          ...prevData,
          [name]: checked ? value : '',
        };
      }

      return {
        ...prevData,
        [name]: value,
      };
    });

    if (name === 'country_id') {
      fetchStates(value);
    }
  };

    const handleCheckboxChange = (e) => {

      const { value, checked } = e.target;

      setFormData((prev) => {
        
        let updatedList = Array.isArray(prev.heard_about) ? [...prev.heard_about] : [];

        if (checked) {
          updatedList.push(value);
        } else {
          updatedList = updatedList.filter((item) => item !== value);
        }

        return {
          ...prev,
          heard_about: updatedList,
        };
      });
    };

    const handlePreferredContactChange = (e) => {
        const { value, checked } = e.target;

        setFormData((prev) => {
          let updatedList = Array.isArray(prev.preferred_contact)
            ? [...prev.preferred_contact]
            : [];

          if (checked) {
            updatedList.push(value);
          } else {
            updatedList = updatedList.filter((item) => item !== value);
          }

          return {
            ...prev,
            preferred_contact: updatedList,
          };
        });
      };

  const validateForm = () => {
    const newErrors = {
      name: '',
      email: '',
      phone: '',
      address: '',
      dob: '',

    };

    if (!formData.name || formData.name.trim() === '') {
      newErrors.name = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(formData.name)) {
      newErrors.name = 'Name should only contain letters and spaces.';
    }

    if (!formData.email || formData.email.trim() === '') {
      newErrors.email = 'Email is required.';
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = 'Invalid email format.';
    }

    if (!formData.phone || formData.phone.trim() === '') {
      newErrors.phone = 'Phone number is required.';
    } else if (!/^\d+$/.test(formData.phone)) {
      newErrors.phone = 'Phone number should only contain numbers.';
    }

    if (!formData.dob || formData.dob.trim() === '') {
      newErrors.dob = 'Date of Birth is required.';
    } else if (!/^\d{4}-\d{2}-\d{2}$/.test(formData.dob)) {
      newErrors.dob = 'Invalid date format. Use YYYY-MM-DD.';
    }




    setErrors(newErrors);

    return Object.values(newErrors).every((error) => error === '');

  };




  const secvalidateForm = () => {
    const newErrors = {

      primary_shopper: '',
      shopping_frequency: '',
      average_spend: '',
      sale_price_usage: '',
      pricing_awareness: '',
    };

    
    if (!formData.primary_shopper) {
      newErrors.primary_shopper = 'Please select an option.';
    }

    if (!formData.shopping_frequency) {
      newErrors.shopping_frequency = 'Please select an option.';
    }

    if (!formData.average_spend) {
      newErrors.average_spend = 'Please enter the value.';
    }

    if (!formData.sale_price_usage) {
      newErrors.sale_price_usage = 'Please select an option.';
    }

    if (!formData.pricing_awareness) {
      newErrors.pricing_awareness = 'Please select an option.';
    }


    setErrors(newErrors);

    console.log(newErrors);

    return Object.values(newErrors).every((error) => error === '');

  };




  const thirdValidateForm = () => {
    const newErrors = {
      consent: '',
    };

    if (formData.consent !== 'Yes') {
      newErrors.consent = 'You must consent to proceed.';
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      ...newErrors,
    }));

    return Object.values(newErrors).every((error) => error === '');
  };

  console.log('Form Data:ewqe', formData.postalcode);

  const handleSubmit = async (e) => {
    e.preventDefault();


    if (!thirdValidateForm()) {
      return;
    }

    setIsloading(true);

    Object.keys(formData).forEach((key) => {
      const field = document.querySelector(`[name="${key}"]`);
      if (field) {
        handleInputChange({ target: field });
      }
    });

    console.log('Form Data:', formData);
    const submissionData = {
      ...formData,

    };

    console.log('Submitting Data: ', submissionData);

    try {
      const method = 'post';
      const url = `${END_URL}profiles`;

      const response = await axios({
        method: method,
        url: url,
        data: submissionData,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      setPopupMessage(`Your details have been ${profileExists ? 'updated' : 'created'} successfully`);

      setShowPopup(true);

      setTimeout(() => {
        setShowPopup(false);
        setPopupMessage('');
        navigate('/dashboard');
      }, 3000);

      setIsloading(false);

      setErrorMessage('');
      console.log('Response data:', response.data);

    } catch (error) {

      setIsloading(false);

      if (error.response) {
        setErrorMessage(`Failed: ${JSON.stringify(error.response.data)}`);
      } else if (error.request) {
        setErrorMessage('No response from server. Check API URL and CORS.');
      } else {
        setErrorMessage(`Request error: ${error.message}`);
      }

      setSuccessMessage('');
    }
  };



  const progressPercentage = () => {
    switch (step) {
      case 1: return '25%';
      case 2: return '50%';
      case 3: return '75%';
      case 4: return '100%';
      default: return '0%';
    }
  };
  const [expanded1, setExpanded] = useState(false);


  const handleTabClick = (tabStep) => {
    setStep(tabStep);
    navigate(`/users/${tabStep}`, { replace: true });
  };


  console.log('heard_about:', formData.heard_about, Array.isArray(formData.heard_about));

  const [isActive, setIsActive] = useState(false);

  const handleActivate = () => { setIsActive(true); };
  const handleCancel = () => { setIsActive(false); };




  return (


    <>

      <div className="dashboard-container full-width">

        <Dashheader />

        {/* {showPopup && (
          <div className="popup">
            <div className="popup-content">
              <div className="pop-img">
                <img src={popImg} alt="Popup-check" />
              </div>
              <h3>Thankyou</h3>
              <p>{popupMessage}</p>
            </div>
          </div>
        )} */}

        <div className="container">
          <div className={`row main-row expanded ${expanded1 ? 'mainmenu' : ''}`}>
            <div className="col-12 col-sm-12 col-md-3 col-lg-3">
              <div className="dashboard-side-div">
                <Sidebar />
                <a href="#" className="expand-btn" onClick={(e) => {
                e.preventDefault();
                setExpanded(!expanded1);
              }}><span></span></a>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-9 col-lg-9">
              <main className="content">

                <div className="form-container">


                  <div className="dashbord-first">
                    {step === 1 ? (
                      <h3>My Profile</h3>
                    ) : (
                      <h3>Shopping Details</h3>
                    )}
                    <p>Keep your details up to date to ensure you receive all case communications.</p>
                    <div className="chip-col">
                      <div className="chip" id='complete'>✅ Profile Complete</div>
                      <div className="chip" id='info'>📬 Contactable</div>
                    </div>
                  </div>

                  <div className="content-card">


                    <div className="card-header">

                        <div className="card-hcnt">

                          <h2>Your Information</h2>

                          <p>Review your current details or make changes.</p>
                          
                        </div>

                        {!isActive && (

                          <button  onClick={handleActivate} className="edit-btn" >Edit Information</button>

                        )}

                    </div>

                      {!isActive && (

                          <div className="profile-view-content">
                            <h3>Personal Details</h3>
                            <div className="row">
                              <div className="col-md-4">
                                <h6>First Name</h6>
                                <h5>{formData.name || '-'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>Last Name</h6>
                                <h5>{formData.lastname || '-'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>Email</h6>
                                <h5>{formData.email || '-'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>Phone</h6>
                                <h5>{formData.phone || '-'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>Date of Birth</h6>
                                <h5>{formData.dob ? new Date(formData.dob).toLocaleDateString() : '-'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>Occupation</h6>
                                <h5>{formData.occupation || '-'}</h5>
                              </div>
                            </div>
                            <h3>Address Details</h3>
                            <div className="row">
                              <div className="col-md-4">
                                <h6>Street Address</h6>
                                <h5>{formData.address || '-'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>City / Suburb</h6>
                                <h5>{formData.city || '-'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>State</h6>
                                <h5>{formData?.state_name || '-'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>Postal Code</h6>
                                <h5>{formData.postalcode || '-'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>Country</h6>
                                <h5>{formData.country?.name || '-'}</h5>

                              </div>
                            </div>

                            <h3>Woolworths Shopping Details</h3>
                            <div className="row">
                              <div className="col-md-4">
                                <h6>Shopped at Woolworths (Sep 2021–May 2023)</h6>
                                <h5>{formData.supermarket_used?.includes('Yes') ? 'Yes' : 'No'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>Primary Shopper</h6>
                                <h5>{formData.primary_shopper || '-'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>Household Size</h6>
                                <h5>{formData.household_people || '-'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>Typical Spend</h6>
                                <h5>{formData.average_spend ? `$${formData.average_spend}` : '-'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>Main Store</h6>
                                <h5>{formData.store_location || '-'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>Shopping Frequency</h6>
                                <h5>{formData.shopping_frequency || '-'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>Bought Due to Woolworths Promotions</h6>
                                <h5>{formData.sale_price_usage === 'Yes' ? 'Yes' : 'No'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>Aware of Pricing Concerns (pre-action)</h6>
                                <h5>{formData.pricing_awareness === 'Yes' ? 'Yes' : 'No'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>How did you hear?</h6>
                                <h5>{Array.isArray(formData.heard_about) ? formData.heard_about.join(', ') : formData.heard_about || '-'}</h5>
                              </div>
                              <div className="col-md-4">
                                <h6>Preferred Contact</h6>
                                <h5>{Array.isArray(formData.preferred_contact) ? formData.preferred_contact.join(', ') : formData.preferred_contact || '-'}</h5>
                              </div>
                            </div>
                          </div>

                      )}

                  

                  <div className={`form-editor ${isActive ? 'active' : ''}`}>

                    {/* <p className="dashbord-second" >Step {step} of 3</p> */}

                    <div className="steps">
                      <ol>
                        <li
                          className={`${step === 1 ? 'active' : ''} ${completedTabs.includes(1) ? 'greenclass' : ''}`}
                          onClick={() => handleTabClick(1)}
                          role="button"
                          tabIndex={0}
                          onKeyPress={(e) => { if (e.key === 'Enter') handleTabClick(1); }}
                        >
                          Personal  
                        </li>
                        <li
                          className={`${step === 2 ? 'active' : ''} ${completedTabs.includes(2) ? 'greenclass' : ''}`}
                          onClick={() => handleTabClick(2)}
                          role="button"
                          tabIndex={0}
                          onKeyPress={(e) => { if (e.key === 'Enter') handleTabClick(2); }}
                        >
                          Address
                        </li>
                        <li
                          className={`${step === 3 ? 'active' : ''} ${completedTabs.includes(3) ? 'greenclass' : ''}`}
                          onClick={() => handleTabClick(3)}
                          role="button"
                          tabIndex={0}
                          onKeyPress={(e) => { if (e.key === 'Enter') handleTabClick(3); }}
                        >
                          Shopping
                        </li>
                        <li
                          className={`${step === 4 ? 'active' : ''} ${completedTabs.includes(4) ? 'greenclass' : ''}`}
                          onClick={() => handleTabClick(4)}
                          role="button"
                          tabIndex={0}
                          onKeyPress={(e) => { if (e.key === 'Enter') handleTabClick(4); }}
                        >
                          Review
                        </li>
                      </ol>

                    </div>


                    {successMessage && <div className="success-message">{successMessage}</div>}
                    {errorMessage && <div className="error-message">{errorMessage}</div>}

                    {step === 1 && (
                      <form className="dashboard-form">

                        <h3>Step 1: Personal Details</h3>

                        <div className="form-group name-div">
                          <label>First Name <span>*</span></label>
                          <div className="form-field">
                            <input
                              type="text"
                              name="name"
                              placeholder=""
                              value={formData.name}
                              onChange={handleInputChange}
                            />
                            {errors.name && <div className="error">{errors.name}</div>}
                            <span></span>
                          </div>
                        </div>


                        <div className="form-group name-div">
                          <label>Last Name <span>*</span></label>
                          <div className="form-field">
                            <input
                              type="text"
                              name="lastname"
                              placeholder=""
                              value={formData.lastname}
                              onChange={handleInputChange}
                            />
                            {/* {errors.name && <div className="error">{errors.name}</div>} */}
                            <span></span>
                          </div>
                        </div>



                        <div className="form-group dashboard-em-ph-div">
                          <div className="form-field">
                            <label>Email <span>*</span></label>
                            <input
                              type="email"
                              name="email"
                              placeholder=""
                              value={formData.email}
                              onChange={handleInputChange}
                              disabled
                            />

                            <div class="mini-hint">Email cannot be changed. Contact support if needed.</div>

                            {errors.email && <div className="error">{errors.email}</div>}
                          </div>


                          <div className="form-field">
                            <label>Phone <span>*</span></label>
                            <input
                              type="text"
                              name="phone"
                              placeholder=""
                              value={formData.phone}
                              onChange={handleInputChange}
                            />
                            {errors.phone && <div className="error">{errors.phone}</div>}
                          </div>
                        </div>








                        <div className="form-group date-occu-div">
                          <div className="form-field date1-div">
                            <label>Date of Birth <span>*</span></label>

                            <input
                              type="date"
                              name="dob"
                              placeholder=""
                              value={formData.dob}
                              onChange={handleInputChange}
                            />
                            {errors.dob && <div className="error">{errors.dob}</div>}
                          </div>




                          <div className="form-field occu-div">
                            <label>Your Occupation</label>
                            <input
                              type="text"
                              name="occupation"
                              placeholder=""
                              value={formData.occupation}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>


                        <div className="button-cta">
                          <button type='button' onClick={handleCancel} className="cancel-btn">Cancel</button>
                          <button
                            type="button"
                            onClick={nextStep}
                            className='next-btn'
                          >
                            Continue
                          </button>
                        </div>



                      </form>
                    )}


                    {step === 2 && (
                      <div>



                        <form className="dashboard-form dashboard-form2">

                          <h3>Step 2: Address Details</h3>


                          <div className="form-group adress-div">
                            <div className="form-field">
                              <label htmlFor="address">Street Address</label>
                              <input
                                type="text"
                                id="address"
                                name="address"
                                placeholder=""
                                value={formData.address}
                                onChange={handleInputChange}
                              />
                              {errors.address && <div className="error">{errors.address}</div>}
                            </div>

                          </div>

                          <div className="form-group city-prov-div">
                            <div className="form-field">
                              <label>City / Suburb</label>
                              <input
                                type="text"
                                id="city"
                                name="city"
                                placeholder=""
                                value={formData.city}
                                onChange={handleInputChange}
                              />
                            </div>

                            <div className="form-field">
                                <label>State</label>
                                    <select
                                      id="state"
                                      name="state"
                                      value={formData.state || ''}
                                      onChange={handleInputChange}
                                    >
                                      <option value="">Please Select</option>
                                      {states.map((state) => (
                                        <option key={state.id} value={state.id}>
                                          {state.name}
                                        </option>
                                      ))}
                                </select>
                                {errors.state && <div className="error">{errors.state}</div>}
                              </div>

                          </div>

                          <div className="form-group post-count-div">

                            <div className="form-field">
                              <label>Postal Code</label>
                              <input
                                type="text"
                                id="postalCode"
                                name="postalcode"
                                placeholder=""
                                value={formData.postalcode}
                                onChange={handleInputChange}
                              />
                            </div>

                            <div className="form-field">
                              <label>Country</label>
                              <select
                                id="country_id"
                                name="country_id"
                                value={formData.country_id || ''}
                                onChange={handleInputChange}
                              >
                                <option value="">Please Select</option>
                                {countries.map((country) => (
                                  <option key={country.id} value={country.id}>
                                    {country.name}
                                  </option>
                                ))}
                              </select>
                              {errors.country && <div className="error">{errors.country}</div>}
                            </div>

                          </div>

                          <div className="button-cta">

                            <button type="button" onClick={prevStep} className="cancel-btn">
                              Back
                            </button>
                            <button type="button" onClick={nextStep} className="next-btn">
                              Continue
                            </button>

                          </div>
                        </form>
                      </div>
                    )}

                    {step === 3 && (
                      <div>

                        <form onSubmit={handleSubmit} className="dashboard-form">

                          <h3>Step 3: Woolworths Shopping Details</h3>

                         <div className="dashbord-2-ip2">

                            <label className="block dsh-lb1">
                                Did you shop at Woolworths between Sep 2021 and May 2023?
                            </label>

                            <div className="space-y-2 mb-4 dash-box2">
                              <label>
                                <input
                                  type="checkbox"
                                  name="supermarket_used"
                                  value="Yes"
                                  checked={formData.supermarket_used === 'Yes'}
                                  onChange={handleInputChange}
                                />
                                Yes
                              </label>

                              <label>
                                <input
                                  type="checkbox"
                                  name="supermarket_used"
                                  value="No"
                                  checked={formData.supermarket_used === 'No'}
                                  onChange={handleInputChange}
                                />
                                No
                              </label>
                              {errors.supermarket_used && <div className="error">{errors.supermarket_used}</div>}
                            </div>

                          </div>


                          <div className="dashbord-2-ip2">
                            <label className="block dsh-lb1">
                              Were you the primary household shopper for Woolworths during this period?
                            </label>

                            <div className="space-y-2 mb-4 dash-box2">
                              <label>
                                <input
                                  type="checkbox"
                                  name="primary_shopper"
                                  value="Yes"
                                  checked={formData.primary_shopper === 'Yes'}
                                  onChange={handleInputChange}
                                />
                                Yes
                              </label>

                              <label>
                                <input
                                  type="checkbox"
                                  name="primary_shopper"
                                  value="No"
                                  checked={formData.primary_shopper === 'No'}
                                  onChange={handleInputChange}
                                />
                                No
                              </label>
                              {errors.primary_shopper && <div className="error">{errors.primary_shopper}</div>}
                            </div>

                          </div>

                          <div className="form-group">
                            <div className="form-field">
                              <label className="">Household size</label>
                              <input
                                type="text"
                                name="household_people"
                                className=""
                                value={formData.household_people}
                                onChange={handleInputChange}
                              />
                              <span>How many people you usually shopped for at Woolworths.</span>
                            </div>


                            <div className="form-field">
                              <label className="">Typical Woolworths shop spend (A$)</label>
                              <input
                                type="text"
                                name="average_spend"
                                className=""
                                value={formData.average_spend}
                                onChange={handleInputChange}
                              />

                              <span>Whole dollars only, no $ sign or cents.</span>

                              {errors.average_spend && <div className="error">{errors.average_spend}</div>}
                            </div>

                          </div>



                          <div className="form-group">
                            <label className="">
                              Main Woolworths store & suburb
                            </label>
                            <input
                              type="text"
                              name="store_location"
                              placeholder='e.g., Woolworths Mudgeeraba, QLD 4213'
                              className=""
                              value={formData.store_location}
                              onChange={handleInputChange}
                            />
                              <span>{'Prefer Woolworths <Suburb>, STATE POSTCODE” rather than an intersection.'}</span>
                          </div>

                          <div className="form-group">

                            <label>How often did you shop at Woolworths during the claim period?</label>
                              <select
                                name="shopping_frequency"
                                value={formData.shopping_frequency}
                                onChange={handleInputChange}
                                className="form-control"
                              >
                                <option value="">Please Select</option>
                                <option value="More than twice a week">More than twice a week</option>
                                <option value="Twice a week">Twice a week</option>
                                <option value="Once a week">Once a week</option>
                                <option value="Every two weeks">Every two weeks</option>
                                <option value="Less frequently">Less frequently</option>
                              </select>
                          </div>


                        <div className="dashbord-2-ip7">

                          <div className="form-group">

                              <div className="form-field">

                                <label className="block dsh-lb1">Did you usually buy items because they were on Woolworths promotion (e.g., “Down Down”, “Prices Dropped”)?</label>
                                <div className="space-y-2 mb-4 dash-box1">
                                  <label>
                                    <input
                                      type="checkbox"
                                      name="sale_price_usage"
                                      value="Yes"
                                      checked={formData.sale_price_usage === 'Yes'}
                                      onChange={handleInputChange}
                                    />
                                    Yes
                                  </label>


                                  <label>
                                    <input
                                      type="checkbox"
                                      name="sale_price_usage"
                                      value="No"
                                      checked={formData.sale_price_usage === 'No'}
                                      onChange={handleInputChange}
                                    />
                                    No
                                  </label>

                                  {errors.sale_price_usage && <div className="error">{errors.sale_price_usage}</div>}
                                </div>
                                
                              </div>

                              <div className="form-field">

                                <label className="block dsh-lb1">Before this action, were you aware of concerns about Woolworths pricing practices?</label>
                                  <div className="space-y-2 mb-4 dash-box1">
                                    <label>
                                      <input
                                        type="checkbox"
                                        name="pricing_awareness"
                                        value="Yes"
                                        checked={formData.pricing_awareness === 'Yes'}
                                        onChange={handleInputChange}
                                      />
                                      Yes
                                    </label>

                                    <label>
                                      <input
                                        type="checkbox"
                                        name="pricing_awareness"
                                        value="No"
                                        checked={formData.pricing_awareness === 'No'}
                                        onChange={handleInputChange}
                                      />
                                      No
                                    </label>
                                    {errors.pricing_awareness && <div className="error">{errors.pricing_awareness}</div>}
                                  </div>

                              </div>

                          </div>

                        </div>

                          <div className="button-cta">
                            <button type="button" onClick={prevStep} className="cancel-btn">
                              Back
                            </button>
                            <button type="button" onClick={nextStep} className="next-btn">
                              Continue
                            </button>
                          </div>
                        </form>
                      </div>
                    )}





                    {step === 4 && (
                      <div>

                        <form onSubmit={handleSubmit} className="dashboard-form">

                          <h3>Step 4: Consent & Review</h3>

                          <div className="form-row">

                            <label>How did you hear about this class action?</label>

                            <div className="space-y-2">

                              {[
                                "News/Media",
                                "Social Media",
                                "Word of Mouth",
                                "Other"
                              ].map((option) => (
                                <label key={option} className="checkbox-item">
                                  <input
                                    type="checkbox"
                                    name="heard_about"
                                    value={option}
                                    checked={
                                      formData.heard_about != null && Array.isArray(formData.heard_about) &&
                                      formData.heard_about?.includes(option)
                                    }
                                    onChange={handleCheckboxChange}
                                  />
                                  {option}
                                </label>
                              ))}

                            </div>
                          </div>


                          {formData?.heard_about?.includes("Other") && (

                            <div className="form-group">
                              <label className="">
                                Other (Please Specify)
                              </label>
                              <input
                                type="text"
                                name="other_specify"
                                placeholder=''
                                className=""
                                value={formData.other_specify}
                                onChange={handleInputChange}
                              />

                            </div>

                          )}

                        <label className="block">Preferred Method of Contact</label>
                          
                        <div className="space-y-2">
                            {["Email", "Phone", "Either"].map((option) => (
                              <label key={option} className="checkbox-item">
                                <input
                                  type="checkbox"
                                  name="preferred_contact"
                                  value={option}
                                  checked={
                                    Array.isArray(formData?.preferred_contact) &&
                                    formData?.preferred_contact?.includes(option)
                                  }
                                  onChange={handlePreferredContactChange}
                                />
                                {option}
                              </label>
                            ))}
                          </div>


                          <div className="review-summary mb-4">
                            <h3>Please review your details before submitting</h3>
                            <div className="review-list">
                              <div><strong>First Name</strong> {formData.name || '-'}</div>
                              <div><strong>Last Name</strong> {formData.lastname || '-'}</div>
                              <div><strong>Email</strong> {formData.email || '-'}</div>
                              <div><strong>Phone</strong> {formData.phone || '-'}</div>
                              <div><strong>Date of Birth</strong> {formData.dob || '-'}</div>
                              <div><strong>Occupation</strong> {formData.occupation || '-'}</div>
                              <div><strong>Street Address</strong> {formData.address || '-'}</div>
                              <div><strong>City / Suburb</strong> {formData.city || '-'}</div>
                              <div><strong>State</strong> {states.find((item) => item.id == formData.state)?.name  || "-"}</div>
                              <div><strong>Postal Code</strong> {formData.postalcode || '-'}</div>
                              <div><strong>Country</strong> {countries.find((item) => item.id == formData.country_id)?.name  || "-"}</div>
                              <div><strong> Shopped at Woolworths</strong> {formData.supermarket_used || '-'}</div>
                              <div><strong>Primary Shopper</strong> {formData.primary_shopper || '-'}</div>
                              <div><strong>Household Size</strong> {formData.household_people || '-'}</div>
                              <div><strong>Typical Spend</strong> {formData.average_spend ? `$${formData.average_spend}` : '-'}</div>
                              <div><strong>Main Store</strong> {formData.store_location || '-'}</div>
                              <div><strong>Shopping Frequency</strong> {formData.shopping_frequency || '-'}</div>
                            </div>
                          </div>

                          <div className="consent space-y-2">
                            <label>
                              <input
                                type="checkbox"
                                name="consent"
                                checked={formData.consent === 'Yes'}
                                onChange={handleInputChange}
                              />
                              I confirm the above details are correct and consent to the <a href="/privacy" target="_blank" rel="noopener">Privacy Policy</a>
                            </label>
                            {errors.consent && <div className="error">{errors.consent}</div>}
                          </div>


                          <div className="button-cta">
                            <button
                              type="button"
                              onClick={prevStep}
                              className="cancel-btn"
                            >
                              Back
                            </button>
                            <button type="submit" className="next-btn">
                                {!Isloading ? 'Save Changes' : 'Saving...' }
                            </button>
                          </div>

                        </form>

                         {/* {showPopup && (
                            <div className="popup">
                              <div className="popup-content">
                                <div className="pop-img">
                                  <img src={popImg} alt="Popup-check" />
                                </div>
                                <h3>Thankyou</h3>
                                <p>{popupMessage}</p>
                              </div>
                            </div>
                          )} */}

                          {showPopup && (

                              <div id="saveSuccessAlert" class="saveSuccessAlert" >
                                  {popupMessage}
                              </div>
                          )}

                      </div>
                    )}

















                  </div>

                    </div>

                </div>


                <UserFooter />


              </main>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
